import { Box, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { UserInfo, Header2, BurgerMenu, Footer2 } from 'Components';
import { useAppSelector, useDispatchApp, useIsOtpLogin } from 'Hooks';
import { useCallback, useEffect, useRef } from 'react';
import { getBurgerMenuItems } from 'API/Home/burgerMenuItems';
import { setMenuItems } from 'Store/MenuItemsSlice';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useFocusFirstPossibleElement } from 'Hooks/useFocusFirstPossibleElement';
import { Feedback } from 'Components/Feedback';
import { B2CGuard } from 'Components/B2CGuard';

export const UniversalRequestLayout = () => {
  const { isOtp, isAuth } = useIsOtpLogin();
  const { inProgress } = useMsal();

  const mainContent = useRef<HTMLDivElement | null>(null);

  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );

  const dispatch = useDispatchApp();

  const initMenuItems = useCallback(async () => {
    if (burgerMenuItems.length === 0 && !isOtp && isAuth) {
      const menuItemsResult = await getBurgerMenuItems();
      dispatch(setMenuItems(menuItemsResult));
    }
  }, [burgerMenuItems.length, isOtp, isAuth, dispatch]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) initMenuItems();
  }, [inProgress, initMenuItems]);

  useFocusFirstPossibleElement(mainContent.current);

  const shouldRenderContent = isAuth && !isOtp;

  return (
    <B2CGuard>
      <div
        style={{
          backgroundColor: 'primary.shade_100',
        }}
      >
        <Stack flexDirection={'row'}>
          {shouldRenderContent && <BurgerMenu top={'80px'} />}
          <Stack ref={mainContent}>
            <Header2 />
            {shouldRenderContent && <UserInfo />}
            <Stack
              sx={{
                overflow: 'hidden',
                minHeight: '100vh',
                backgroundColor: 'primary.shade_100',
                '&& *': { fontFamily: 'Assistant' },
              }}
              component={'main'}
              tabIndex={-1}
            >
              {shouldRenderContent && <Outlet />}
            </Stack>
            {shouldRenderContent && (
              <Box sx={{ '& div': { ml: '0px' } }}>
                <Feedback />
              </Box>
            )}
            <Footer2 />
          </Stack>
        </Stack>
      </div>
    </B2CGuard>
  );
};
